// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"592e6685","257":"4fb87fbc"}[chunkId] + ".chunk.css";
};